import { Button } from './ui'

const triggerGroupClass =
  'flex items-center rounded-lg border border-gray-200 bg-gray-50/80 p-0.5 dark:border-gray-600 dark:bg-gray-800/60'

interface TomAssistantTriggerProps {
  onClick: () => void
  title: string
  ariaLabel: string
  disabled?: boolean
  /** Wie aktiver Theme-Button (z. B. Aufnahme läuft) */
  active?: boolean
}

export default function TomAssistantTrigger({
  onClick,
  title,
  ariaLabel,
  disabled = false,
  active = false,
}: TomAssistantTriggerProps) {
  return (
    <div className={triggerGroupClass} role="group" aria-label="Hilfe-Assistent Tom">
      <Button
        type="button"
        size="sm"
        variant={active ? 'primary' : 'ghost'}
        className="h-8 w-8 shrink-0 px-0 font-semibold leading-none text-gray-700 dark:text-gray-200"
        title={title}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
      >
        <span className="text-lg" aria-hidden>
          ?
        </span>
      </Button>
    </div>
  )
}
